import React, { useEffect, useState } from "react";
import SlideoverModal from "../../components/SlideoverModal";
import {
  FormCheck,
  FormInput,
  FormLabel,
  FormSelect,
  FormSwitch,
} from "../../base-components/Form";
import Lucide from "../../base-components/Lucide";
import Button from "../../base-components/Button";
import _ from "lodash";
import { createCustomer, updateCustomer } from "src/stores/customer";
import { RootState } from "src/stores";
import { connect } from "react-redux";
import { createUpdateCustomerProps, locationProps } from "src/interfaces";
import PhoneInput from "src/components/PhoneInput";
import { PlusIcon, XCircleIcon } from "lucide-react";
import ErrorMessage from "src/base-components/FormErrorValidation/ErrorMessage";
import WhatsappIcon from "../../assets/images/icon/whatsapp-logo.svg";
import { parsePhoneNumber } from "libphonenumber-js";
const Component = ({
  visible,
  setVisible,
  model = {} as any,
  setModel = () => {},
  onCreate,
  onUpdate,
  onCreateUpdateComplete,
  isView = false,
}: {
  visible: boolean;
  setVisible: Function;
  editing?: boolean;
  model?: createUpdateCustomerProps;
  setModel?: (payload: createUpdateCustomerProps) => void;
  onCreate: (payload: createUpdateCustomerProps) => void;
  onUpdate: (payload: createUpdateCustomerProps) => void;
  onCreateUpdateComplete?: Function;
  isView?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const [addAlternatePhone, setAddAlternatePhone] = useState(false);
  const [addedPhones, setAddedPhones] = useState<string[]>([]);
  const [currentPhone, setCurrentPhone] = useState<string>("");
  const [alreadyAddedPhone, setAlreadyAddedPhone] = useState<boolean>(false);
  const [repeatError, setRepeatError] = useState<boolean>(false);
  const handleAlternatePhone = (payload: {
    phone: string;
    dialCode: string;
  }) => {
    setCurrentPhone(payload?.dialCode + payload?.phone);
    setAlreadyAddedPhone(false);
  };
  useEffect(() => {
    if (model?.alternative_phone_numbers) {
      const arr = model?.alternative_phone_numbers
        .split(",")
        .map((s) => s.trim());
      setAddedPhones(arr);
    } else {
      setAddedPhones([]);
    }
  }, [model?.alternative_phone_numbers]);

  const handleAddPhone = () => {
    if (
      addedPhones.includes(currentPhone) ||
      currentPhone === model?.country_code + model?.phone
    ) {
      setAlreadyAddedPhone(true);
      return;
    } else {
      setAlreadyAddedPhone(false);
    }
    if (currentPhone && !addedPhones.includes(currentPhone)) {
      let newSet = [...addedPhones, currentPhone];
      setAddedPhones(newSet);
      setCurrentPhone("");
      setModel({
        ...model,
        alternative_phone_numbers:
          newSet?.length > 0 ? newSet?.join(", ") : null,
      });
      setAddAlternatePhone(false);
    }
  };

  const handleRemovePhone = (phoneToRemove: string) => {
    let newSet = addedPhones.filter((phone) => phone !== phoneToRemove);
    if (phoneToRemove === model.wp_country_code + model?.whatsapp_phone) {
      setModel({ ...model, whatsapp_phone: "", wp_country_code: "" });
    }
    setAddedPhones(newSet);
    setModel({
      ...model,
      alternative_phone_numbers: newSet?.length > 0 ? newSet?.join(", ") : null,
    });
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isView) {
      return;
    }

    setLoading(true);
    let payload: any = model;
    if (payload?.id) {
      onUpdate({
        ...payload,
        callback: (isError: boolean) => {
          setVisible(!!isError);
          setCurrentPhone("");
          setAddAlternatePhone(false);
          setAlreadyAddedPhone(false);
          setLoading(false);
          onCreateUpdateComplete && onCreateUpdateComplete(isError);
        },
      } as any);
      return;
    }
    Object.keys(payload)?.map((key) => {
      if (!payload[key]) {
        delete payload[key];
      }
    });
    payload.isDefault = model?.isDefault ? model?.isDefault : 0;
    onCreate({
      ...payload,
      callback: (isError: boolean) => {
        setVisible(!!isError);
        setCurrentPhone("");
        setAddAlternatePhone(false);
        setAlreadyAddedPhone(false);
        setLoading(false);
        onCreateUpdateComplete && onCreateUpdateComplete(isError);
      },
    } as any);
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isView) {
      return;
    }
    const name = event?.target?.name;
    const value = event?.target?.value;
    setModel({
      ...model,
      [name]: value,
    });
  };

  return (
    <SlideoverModal
      size="md"
      headerTitle={
        isView
          ? "Customer"
          : model?.id
          ? "Update Customer"
          : "Create New Customer"
      }
      visible={visible}
      onClose={(value) => {
        setVisible(value);
        setCurrentPhone("");
        setAddAlternatePhone(false);
        setAlreadyAddedPhone(false);
      }}
    >
      <form onSubmit={onSubmit} className="flex flex-col">
        <div className="w-full">
          <FormLabel>Full Name</FormLabel>
          <FormInput
            w-full
            onChange={onChange}
            value={model?.fullname || ""}
            required
            readOnly={isView}
            name="fullname"
            type="text"
            className="rounded-md"
            placeholder={"Enter full name"}
          />
        </div>
        <div className="w-full mt-3">
          <FormLabel>Email</FormLabel>
          <FormInput
            readOnly={isView}
            onChange={onChange}
            value={model?.email || ""}
            type="email"
            name="email"
            placeholder={"Enter email"}
          />
        </div>
        <div className="w-full mt-3 relative">
          <FormLabel className="">Phone (primary)</FormLabel>{" "}
          {isView ? (
            <FormInput
              required
              readOnly={isView}
              value={`${model?.country_code}${model?.phone}` || ""}
              placeholder={"Phone"}
            />
          ) : (
            <div>
              <div className="flex space-x-3 w-full">
                <PhoneInput
                  {...({} as any)}
                  value={`${model?.country_code}${model?.phone}` || ""}
                  name="phone"
                  placeholder="#Phone"
                  className="rounded-r-md z-10"
                  onChange={(payload) => {
                    const { phone, dialCode } = payload;
                    if (addedPhones?.includes(dialCode + phone)) {
                      setRepeatError(true);
                      return;
                    } else {
                      setRepeatError(false);
                    }

                    if (isView) {
                      return null;
                    }
                    setModel({
                      ...model,
                      phone: phone,
                      country_code: dialCode,
                    });
                  }}
                />

                <div className="flex items-center">
                  <FormCheck.Input
                    value={model?.isDefault}
                    checked={model?.isDefault == 1}
                    onChange={() => {
                      setModel({
                        ...model,
                        isDefault: model?.isDefault == 0 ? 1 : 0,
                        wp_country_code: "",
                        whatsapp_phone: "",
                      });
                    }}
                    id="remember-me"
                    name="isPersist"
                    type="checkbox"
                    className="mr-2 border"
                  />
                  <label className="cursor-pointer select-none">
                    <img src={WhatsappIcon} className="w-8 h-8" />
                  </label>
                </div>
              </div>
              {repeatError ? (
                <ErrorMessage
                  message={
                    "This phone number has already been added. Please enter a different number." as any
                  }
                />
              ) : null}
            </div>
          )}
          {addedPhones.length > 0 && (
            <div className="flex flex-col gap-2 mt-3 w-full">
              <span className="flex flex-row items-center justify-items-end text-primary font-bold mt-4 cursor-pointer">
                Alternate Phone Numbers
              </span>
              {addedPhones.map((phone, index) => (
                <div
                  key={index}
                  className="flex w-full items-center justify-between "
                >
                  <div className="flex flex-row items-center">
                    <PhoneInput
                      {...({} as any)}
                      value={phone || ""}
                      name="phone"
                      placeholder="#Phone (alternate)"
                      disabled={true}
                      className="rounded-r-md z-10"
                      onChange={(payload) => {}}
                    />

                    <FormCheck.Input
                      onClick={() => {
                        console.log(
                          model?.wp_country_code,
                          model?.whatsapp_phone,
                          phone
                        );

                        let countryCode = "";
                        let nationalNumber = "";

                        try {
                          const parsed = parsePhoneNumber(phone || "");
                          countryCode = `+${parsed.countryCallingCode}`;
                          nationalNumber = parsed.nationalNumber;
                        } catch (e) {
                          console.error("Invalid phone number", e);
                        }

                        setModel({
                          ...model,
                          isDefault: 0,
                          wp_country_code:
                            model?.whatsapp_phone === nationalNumber
                              ? ""
                              : countryCode,
                          whatsapp_phone:
                            model?.whatsapp_phone === nationalNumber
                              ? ""
                              : nationalNumber,
                        });
                      }}
                      id="remember-me"
                      name="isPersist"
                      type="checkbox"
                      className="mx-2 border"
                      checked={
                        model?.wp_country_code + model?.whatsapp_phone === phone
                      }
                    />
                    <label className="cursor-pointer select-none">
                      <img src={WhatsappIcon} className="w-8 h-8" />
                    </label>
                  </div>
                  <XCircleIcon
                    className="text-red-600 w-4 h-4 cursor-pointer"
                    onClick={() => handleRemovePhone(phone)}
                  />
                </div>
              ))}
            </div>
          )}
          {!isView && addAlternatePhone && addedPhones?.length < 4 ? (
            <div>
              <div className="flex flex-row gap-3 justify-start items-center mt-3 w-full">
                <PhoneInput
                  {...({} as any)}
                  value={currentPhone}
                  placeholder="Alternate Phone Number"
                  className="border-slate-300/100 w-[100%] "
                  onChange={handleAlternatePhone}
                />
                {currentPhone?.length > 6 && (
                  <Button
                    className="flex items-center py-1 cursor-pointer justify-center md:w-auto text-white bg-primary"
                    type="button"
                    onClick={handleAddPhone}
                  >
                    <Lucide
                      icon="Check"
                      className="stroke-[2] w-4 h-4 mr-2 -ml-2"
                    />
                    Add
                  </Button>
                )}

                <XCircleIcon
                  className="flex items-center text-red-900  w-7 h-6 border-none rounded-full cursor-pointer"
                  onClick={() => {
                    setAddAlternatePhone(!addAlternatePhone);
                  }}
                />
              </div>
              {alreadyAddedPhone ? (
                <ErrorMessage
                  message={
                    "This phone number has already been added. Please enter a different number." as any
                  }
                />
              ) : null}
            </div>
          ) : addedPhones?.length < 4 && !isView ? (
            <span
              onClick={() => {
                setAddAlternatePhone(!addAlternatePhone);
              }}
              className="flex flex-row items-center justify-items-end text-primary font-bold mt-4 cursor-pointer"
            >
              <PlusIcon className="mr-0.5" size={18} />{" "}
              {addedPhones?.length > 0
                ? "Add more"
                : "Add Alternate Phone Numbers"}
            </span>
          ) : null}
        </div>
        {!isView && (
          <div className="absolute bottom-0 right-0 py-5 px-7">
            <Button
              className="w-full px-10 md:w-auto text-white bg-primary mt-auto ml-auto"
              type="submit"
              disabled={loading}
              loading={loading}
            >
              <Lucide
                icon="Check"
                className="stroke-[1.3] w-4 h-4 mr-2 -ml-2"
              />
              Submit
            </Button>
          </div>
        )}
      </form>
    </SlideoverModal>
  );
};

const mapStateToProps = ({ roles, locations }: RootState) => ({
  roles,
  locations,
});

const mapDispatchToProps = (dispatch: any) => ({
  onCreate: (payload: any) => dispatch(createCustomer(payload)),
  onUpdate: (payload: any) => dispatch(updateCustomer(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Component);
